import React from 'react'
import { useHistory } from 'react-router-dom'

import { Modal, Button, Row } from '_zari/core'

import { AdminContext } from 'contexts/AdminContext'

import { CodigosTransaccionesConstant } from 'constants/index'

import * as FacturacionService from 'services/facturacion.service'

import * as Formats from './formats'

const PreviewPdfModal = ({ show, handleClose, reiniciarFormulario, pdfHash, flagSinEntrega, flagVentaRapida }) => {
  const __adminContext = React.useContext(AdminContext)

  const [mostrarSegundaImpresion, setMostrarSegundaImpresion] = React.useState(false)

  const history = useHistory()

  const clickContinuar = React.useCallback(() => {
    if (__adminContext.valoresConfiguracionUsuario.flagPuntoVenta) {
      reiniciarFormulario()
    } else {
      handleClose()
      if (flagSinEntrega) {
        history.push(`/${CodigosTransaccionesConstant.VENTAS_SINENTREGA_LISTA}`)
      } else if (flagVentaRapida) {
        history.push(`/${CodigosTransaccionesConstant.VENTASRAPIDAS_LISTA}`)
      } else {
        history.push(`/${CodigosTransaccionesConstant.VENTAS_LISTA}`)
      }
    }
  }, [__adminContext, handleClose, history, reiniciarFormulario, flagSinEntrega, flagVentaRapida])

  React.useEffect(() => {
    if (__adminContext.valoresConfiguracionCompania.flagDobleImpresora) {
      FacturacionService.validarSegundaImpresionxId(pdfHash)
        .then(() => {
          setMostrarSegundaImpresion(true)
        })
        .catch(() => {
          setMostrarSegundaImpresion(false)
        })
    }
  }, [__adminContext, pdfHash])

  return (
    <Modal
      show={show}
      onHide={handleClose}
      fullSize={!!__adminContext.valoresConfiguracionCompania.flagDobleImpresora}
      size={__adminContext.valoresConfiguracionCompania.flagDobleImpresora ? 'md' : 'lg'}
    >
      <Modal.Body>
        <Row>
          {__adminContext.valoresConfiguracionCompania.flagDobleImpresora ? (
            <>
              <Formats.EstandarFormat md={mostrarSegundaImpresion ? 6 : 12} pdfHash={pdfHash} />
              {mostrarSegundaImpresion && <Formats.SegundaImpresionFormat pdfHash={pdfHash} />}
            </>
          ) : (
            <Formats.EstandarFormat md={12} pdfHash={pdfHash} />
          )}
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={clickContinuar}>Continuar</Button>
      </Modal.Footer>
    </Modal>
  )
}

export default React.memo(PreviewPdfModal)
